module.exports = __webpack_public_path__ + "6d445cb4a6bf2f8f3c8986b2c7de82b1.png";